import React, { useState, useCallback } from "react";
import Tree from "react-d3-tree";
import DeleteNodeModal from "./modals/DeleteNodeModal";
import CustomNode from "./CustomNode";
import AddNodeModal from "./modals/AddNodeModal";
import EditNodeModal from "./modals/EditNodeModal";
import styles from "./chatbot.module.css";
import styles1 from "src/components/apps/liveChat/chatList/chat.module.css";
import "./styles.css";
import chatBg from "../../assets/images/chatBuilder/chat_bg.png";
import useChatbotTree from "./hooks/useChatbotTree";
import { ButtonLoader, ButtonLoaderLeft } from "src/components/forms/ButtonLoader";
import ChatbotProfile from "./ChatbotProfile";
import { useSelector } from "react-redux";
import PublishModal from "src/components/custom/PublishModal";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const ChatBotTree = ({ treeData, userdata, getUserListData, isLoading, isAccountSetup = false, handleNext }) => {
  const userObj = useSelector((state) => state.auth.user);

  const [orgData, setOrgData] = useState(treeData);
  const [toggleDelete, setDeleteToggle] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);
  const [editorOpen, setEditorOpen] = useState(false);
  const [publishModal, setPublishModal] = useState(false);
  const [toggleAddChildForm, setToggleAddChildForm] = useState(false);
  const [toggleEditChildForm, setToggleEditChildForm] = useState(false);
  const { isPublishLoading, publishChatbotTree, publishedChatbot, toggleAllChildren, mergeNodetoTree, setPublishedChatbot, getNodeLabel } = useChatbotTree();

  const handleAddButtonClick = useCallback((nodeData) => {
    setSelectedNode(nodeData);
    setToggleAddChildForm(true);
  }, []);

  const handleEditButtonClick = useCallback((nodeData) => {
    setSelectedNode(nodeData);
    setToggleEditChildForm(true);
  }, []);

  const handleDeleteButtonClick = useCallback(
    async (nodeData) => {
      setSelectedNode(nodeData);
      setDeleteToggle(true);
    },
    [orgData]
  );

  const toggleVisibility = (selectedNodeData) => {
    const updatedNodeData = toggleAllChildren(selectedNodeData, selectedNodeData?.children[0].isVisible);
    const updatedNodeTreeData = mergeNodetoTree(orgData, updatedNodeData);
    setOrgData((prevData) => updatedNodeTreeData);
  };

  const renderCustomNodeElement = useCallback(
    ({ nodeDatum, toggleNode }) => (
      <>
        {nodeDatum.isVisible === undefined || nodeDatum.isVisible === true ? (
          <CustomNode
            nodeData={nodeDatum}
            toggleNode={() => { toggleNode() }}
            toggleVisibility={toggleVisibility}
            onAddButtonClick={handleAddButtonClick}
            onEditButtonClick={handleEditButtonClick}
            onDeleteButtonClick={handleDeleteButtonClick}
            getNodeLabel={getNodeLabel}
          />
        ) : null}
      </>
    ),
    [handleAddButtonClick, handleEditButtonClick, handleDeleteButtonClick]
  );

  const onAddNodeSuccess = (newNodeData) => {
    setOrgData(newNodeData);
    setToggleAddChildForm(false);
  };

  const onEditNodeSuccess = (newNodeData) => {
    setOrgData(newNodeData);
    setToggleEditChildForm(false);
  };

  const pathClassFunc = (linkData, orientation) => {
    const { source, target } = linkData;

    if (source.data?.children[0]?.isVisible === false) {
      return 'path-color-1';
    } else {
      return '';
    }
  }


  console.log(orgData);

  return (
    <>
      <div className="bg-white">
        <div className={styles.custom_header + " App pb-0   "}>
          <div className={` ${isAccountSetup ? "px-5" : "px-0"} row mx-0 align-items-center`}>
            <div className="col-md-6 text-start">
              <div className={styles.custom_header_toggle}>

                <div className={styles1.chatfilter_switch}>
                  <div
                  style={isAccountSetup ? {fontSize:"20px"} : {}}
                    className={
                      styles1.chatfilter_switch_tab +
                      " " +
                      (!editorOpen ? styles1.chatfilter_switch_tab_active : "")
                    }
                    onClick={() => {
                      setEditorOpen(false);
                    }}
                  >
                    Chatbot Builder
                  </div>
                  {!isAccountSetup && <div onClick={() => { setEditorOpen(true);}}
                    className={ styles1.chatfilter_switch_tab + " " + (editorOpen ? styles1.chatfilter_switch_tab_active : "") }> Chatbot Setting </div>}
                  <div className={styles.chatfilter_active}>
                  {!isAccountSetup && <div style={{ right: editorOpen ? "10rem" : "" }}></div>}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 text-end">
              {isAccountSetup ?
                <div className="d-flex align-items-center justify-content-end">
                  <div style={{marginTop:"2rem"}}>
                    <ButtonLoaderLeft
                      onClickhandle={() => { handleNext("back") }}
                      // isLoading={isLoading}
                      buttonName="Back"
                      loaderColor={"white"}
                      className={styles.back_btn}
                      icon={<KeyboardArrowLeftIcon />}
                    ></ButtonLoaderLeft>
                  </div>
                  <ButtonLoader
                    buttonName={publishedChatbot ? "Published" : "Publish"}
                    isLoading={isPublishLoading}
                    className={styles.setup_publish_btn}
                    onClickhandle={() => publishChatbotTree(setPublishModal)}
                  />
                  <div style={{marginLeft:"10px"}}>
                    <ButtonLoader
                      onClickhandle={() => { handleNext() }}
                      // isLoading={isLoading}
                      buttonName="Next"
                      loaderColor={"white"}
                      className={styles.save_btn}
                      icon={<KeyboardArrowRightIcon />}
                    ></ButtonLoader>
                  </div>

                 
                </div>
                :
                <ButtonLoader
                  buttonName={publishedChatbot ? "Published" : "Publish"}
                  isLoading={isPublishLoading}
                  className={styles.publish_btn}
                  onClickhandle={() => publishChatbotTree(setPublishModal)}
                />
              }
            </div>
          </div>

          {!editorOpen ? (
            <div
              id="treeWrapper"
              style={{
                width: "100%",
                height: "calc(100vh - 114px)",
                backgroundImage: `url(${chatBg})`,
              }}
            >
              {orgData && orgData?.length ? (
                <Tree
                  className={styles.tree_view}
                  data={orgData}
                  orientation="vertical"
                  allowForeignObjects={true}
                  separation={{ siblings: 2, nonSiblings: 2 }}
                  pathFunc="step"
                  renderCustomNodeElement={renderCustomNodeElement}
                  translate={{ x: window.innerWidth / 2, y: 80 }}
                  collapsible={true}
                  pathClassFunc={pathClassFunc}
                />
              ) : (
                <div>
                  Add Tree
                  <button onClick={() => setToggleAddChildForm(true)}>
                    {" "}
                    a Node
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div style={{
              width: "100%",
              height: "calc(100vh - 114px)",
              backgroundI: 'white',
            }}>
              <ChatbotProfile userdata={userdata} getUserListData={getUserListData} isLoading={isLoading} isAccountSetup={isAccountSetup} />
            </div>
          )}
        </div>

        {selectedNode && <AddNodeModal
          toggleAddChildForm={toggleAddChildForm}
          orgData={orgData}
          selectedNode={selectedNode}
          closeModal={() => setToggleAddChildForm(false)}
          onSuccess={onAddNodeSuccess}
          setPublishedChatbot={setPublishedChatbot}
          categories={userObj?.departmentRole}
          categoriesProperty={userObj?.departmentType}
        />}

        {toggleEditChildForm && (
          <EditNodeModal
            toggleEditChildForm={toggleEditChildForm}
            orgData={orgData}
            selectedNode={selectedNode}
            closeModal={() => setToggleEditChildForm(false)}
            onSuccess={onEditNodeSuccess}
            setPublishedChatbot={setPublishedChatbot}
            categories={userObj?.departmentRole}
            categoriesProperty={userObj?.departmentType}
          />
        )}

        {toggleDelete && (
          <DeleteNodeModal
            isOpen={toggleDelete}
            setDeleteToggle={setDeleteToggle}
            orgData={orgData}
            setOrgData={setOrgData}
            targetNode={selectedNode}
            setPublishedChatbot={setPublishedChatbot}
          />
        )}

        {publishModal && (
          <PublishModal
            open={publishModal}
            closeModal={() => setPublishModal(false)}
          />
        )}
      </div>
    </>
  );
};

export default ChatBotTree;
